import http, { BASE_URL, BASE_URL_3 } from '../../http';
import { getRBPStringId } from '../../../page/main/main-page-states';

/**
 * 云 RBP DIS 相关接口：KDS 发票打印机、餐厅税务主体、GYB 设备。
 * 与 RBP2 `src/request/api/dis.ts` 语义一致，路径携带当前餐厅 `string_id`。
 */
const disRbpApi = {
    /**
     * 获取门店下可用于 DIS 测试打印的 KDS 打印机列表。
     */
    async getKdsPrintersLocation(): Promise<any> {
        return await http.get(`${BASE_URL}/kds/printers/location/${getRBPStringId()}`);
    },

    /**
     * 按 IP/协议测试 DIS 打印机连通性。
     * @param params - 打印机类型、连接串、打印模式（与 RBP2 一致）
     */
    async postTestPrinterIp(params: { type: string; theinterface: string; printMode: number }): Promise<any> {
        return await http.post(`${BASE_URL_3}/printer/test/ip/${getRBPStringId()}`, params);
    },

    /**
     * 拉取餐厅税务信息列表。
     * @param isSpain - 是否西班牙门店（走 es-restaurantinfo 分支）
     */
    async postKdsRestaurantInfoList(isSpain: boolean): Promise<any> {
        const branch = isSpain ? 'es-restaurantinfo' : 'restaurantinfo';
        return await http.post(`${BASE_URL_3}/kds/${branch}/get/${getRBPStringId()}`, {});
    },

    /**
     * 新增餐厅税务信息。
     */
    async postCreateKdsRestaurantInfo(data: Record<string, unknown>, isSpain: boolean): Promise<any> {
        const branch = isSpain ? 'es-restaurantinfo' : 'restaurantinfo';
        return await http.post(`${BASE_URL_3}/kds/${branch}/${getRBPStringId()}`, { data });
    },

    /**
     * 编辑餐厅税务信息（按 id + key/value 数组批量更新）。
     */
    async patchKdsRestaurantInfo(
        param: { id: number[]; key: string[]; value: string[] },
        isSpain: boolean,
    ): Promise<any> {
        const branch = isSpain ? 'es-restaurantinfo' : 'restaurantinfo';
        return await http.patch(`${BASE_URL_3}/kds/${branch}/${getRBPStringId()}`, param);
    },

    /**
     * 删除单条餐厅税务信息。
     * @param id - 税务记录 id
     */
    async deleteKdsRestaurantInfo(id: number, isSpain: boolean): Promise<any> {
        const branch = isSpain ? 'es-restaurantinfo' : 'restaurantinfo';
        return await http.delete(`${BASE_URL_3}/kds/${branch}/${getRBPStringId()}`, { data: { id } });
    },

    /**
     * 获取 GYB 设备列表。
     */
    async getGybDeviceInfo(): Promise<any> {
        return await http.get(`${BASE_URL_3}/gyb-device/${getRBPStringId()}`);
    },

    /**
     * 从云端同步 GYB 设备数据。
     */
    async patchGybSyncDevices(): Promise<any> {
        return await http.patch(`${BASE_URL_3}/gyb/sync_devices/${getRBPStringId()}`);
    },

    /**
     * 将指定 GYB 设备设为默认开票设备。
     * @param id - 设备记录 id
     */
    async patchSetGybDefaultDevice(id: number): Promise<any> {
        return await http.patch(`${BASE_URL_3}/gyb/device/default/${id}/${getRBPStringId()}`);
    },

    /**
     * 取消 GYB 默认设备绑定。
     * @param id - 设备记录 id
     */
    async deleteSetGybDefaultDevice(id: number): Promise<any> {
        return await http.delete(`${BASE_URL_3}/gyb/device/default/${id}/${getRBPStringId()}`);
    },
};

export default disRbpApi;
